//own imports
import { ThemeContext } from "../../../App";

import React, { Component } from "react";

import './ToggleSwitch.css';

class DarkModeToggle extends Component {
  constructor(props) {
    let currentTheme = localStorage.getItem('Theme');
    if (currentTheme === null) {
      currentTheme = 'light';
    }
    super(props);
    this.state = {
      isChecked: currentTheme === 'dark',
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(theme) {
    this.setState({ isChecked: !this.state.isChecked });
    //Write code to store theme in local storage

    if (theme.theme === 'dark') {
      localStorage.setItem('Theme', 'light');
    } else {
      localStorage.setItem('Theme', 'dark');
    }

  }
  render() {
    return (
      <ThemeContext.Consumer>
        {({ theme, toggleTheme }) => (
          <label className="switch">
            <input type="checkbox"  checked={this.state.isChecked} onChange={() => {toggleTheme();  this.handleClick(theme);}}/>
            <div className="slider"></div>
      </label>
        )}
      </ThemeContext.Consumer>
    );
  }
}

export default DarkModeToggle;